import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import DataTable from "react-data-table-component";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ChecklistIcon from "@mui/icons-material/Checklist";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

import NavbarSA from "../../../components/navbar-sa";
import AddUserModal from "../../../components/Addusermodel";
import server from "../../../variables";
import GenerateBillModal from "../../../components/BillGenerate";
import BillModal from "../../../components/Addbillmodel";
import BillGenerateReport from "../../../components/Reportsgenerate";

const SchemeDashboard = () => {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const { id: schemeID } = useParams();

  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [showUserModal, setShowUserModal] = useState(false);
  const [biilmodelshow, setBillmodel] = useState(false);
  const [editData, setEditData] = useState(null); // store user data for editing
  const [showBillreportModal,setBillreportmodal] = useState(false)
  useEffect(() => {
    document.title = "Scheme Users | RBS";
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const { data } = await Axios.get(
        `${server}admin/get-all-user/${schemeID}`,
        { headers: { authorization: localStorage.getItem("token") } },
      );

      if (data.status === 410) return navigate("/");
      if (data.status !== 200) throw new Error(data.message);

      setUsers(data.user);
    } catch (err) {
      notyf.error("Failed to load users");
    }
  };

  const filteredUsers = useMemo(() => {
    return users.filter((u) =>
      search
        ? `${u.name}${u.email}${u.userID}`
            .toLowerCase()
            .includes(search.toLowerCase())
        : true,
    );
  }, [users, search]);

  const columns = useMemo(
    () => [
      { name: "User ID", selector: (r) => r.userID, sortable: true },
      { name: "Name", selector: (r) => r.name, sortable: true, wrap: true },
      { name: "Email", selector: (r) => r.email, sortable: true },
      {
        name: "Actions",
        center: true,
        cell: (row) => (
          <div className="d-flex gap-2 justify-content-center">
            <EditIcon
              style={{ cursor: "pointer", color: "#f0ad4e" }}
              onClick={() => {
                setEditData(row); // set the user to edit
                setShowUserModal(true); // open modal
              }}
            />
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <div className="page-wrapper bg-light min-vh-100">
      <div className="container p-3">
        {/* Top Cards */}
        <div className="row g-4">
          {[
            { label: "Users" },
            { label: "Consumers", link: `/admin/scheme/${schemeID}/consumers` },
          ].map((card) => (
            <div className="col-12 col-md-6" key={card.label}>
              <div
                className="card shadow-sm rounded-4 border-0"
                style={{
                  cursor: card.link ? "pointer" : "default",
                  minHeight: "100px",
                }}
                onClick={() => card.link && navigate(card.link)}
              >
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div>
                    <span className="h5 mb-0">{card.label}</span>
                  </div>
                  <ChecklistIcon
                    className="text-primary"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Table Section */}
        <div className="card shadow-sm rounded-4 p-4 border-0 mt-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-3">
            <div className="input-group shadow-sm search-input">
              <span className="input-group-text bg-white border-0">
                <i className="bi bi-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search by name, email or ID"
           
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
                data-bs-toggle="tooltip"
                  data-bs-placement="top"
              title="Add Users"
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => {
                setEditData(null); // ensure no edit data for new user
                setShowUserModal(true);
              }}
            >
              <AddIcon />
            </button>
            <button
                 data-bs-toggle="tooltip"
               data-bs-placement="top"
              title="Generate Bils "
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => {
                setBillmodel(true);
              }}
            >
              <i className="bi bi-receipt"></i>
            </button>
            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Export CSV"
              onClick={() => {
                setBillreportmodal(true);
              }}
            >
              <i className="bi bi-download"></i>
            </button>
          </div>

          <DataTable
            columns={columns}
            data={filteredUsers}
            pagination
            highlightOnHover
            striped
            responsive
            noDataComponent="No users found"
            className="rounded-3"
          />
        </div>
      </div>

      {/* Add/Edit User Modal */}
      <AddUserModal
        show={showUserModal}
        handleClose={() => setShowUserModal(false)}
        schemeID={schemeID}
        refresh={fetchUsers}
        editData={editData} // pass user data for edit
      />
      <GenerateBillModal
        show={biilmodelshow}
        schemeID={schemeID}
        handleClose={() => setBillmodel(false)}
      />


       <BillGenerateReport
        showModal={showBillreportModal}
        setShowModal={setBillreportmodal}
      />
    </div>
  );
};

export default SchemeDashboard;
